import PropTypes from 'prop-types';
import { Modal } from '@bwoty-web/ui-kit';
import RoomType from '../../../../common/roomType';

const RoomTypePopup = ({
  isConceptHotel,
  accommodationSection,
  toggleRoomInfo,
  roomType,
  generalUspList,
  showPartInfoRoomList,
}) => {
  return (
    <Modal
      onClose={() => toggleRoomInfo()}
      className="gw-room-type-popup--scroll-anchor"
      size="m"
      overlayedCloseButton
    >
      <RoomType
        isConceptHotel={isConceptHotel}
        accommodationSection={accommodationSection}
        toggleRoomInfo={toggleRoomInfo}
        roomType={roomType}
        generalUspList={generalUspList}
        showPartInfoRoomList={showPartInfoRoomList}
        inPopup
      />
    </Modal>
  );
};

RoomTypePopup.propTypes = {
  isConceptHotel: PropTypes.bool.isRequired,
  showPartInfoRoomList: PropTypes.bool.isRequired,
  accommodationSection: PropTypes.shape({}).isRequired,
  toggleRoomInfo: PropTypes.func.isRequired,
  generalUspList: PropTypes.shape({}),
  roomType: PropTypes.shape({ name: PropTypes.string }),
};

RoomTypePopup.defaultProps = {
  roomType: null,
  generalUspList: null,
};

export default RoomTypePopup;
